<template>
  <div v-if="dataArr&&dataArr.length">
    <Carousel
      class="freshNew"
      v-model="Carousel.indx"
      :height="Carousel.setting.height"
      :autoplay="Carousel.setting.autoplay"
      :autoplay-speed="Carousel.setting.autoplaySpeed"
      :dots="Carousel.setting.dots"
      :radius-dot="Carousel.setting.radiusDot"
      :trigger="Carousel.setting.trigger"
      :arrow="Carousel.setting.arrow"
    >
      <CarouselItem  v-for="(item,index) in dataArr" :key="index" v-if="index<=3" >
        <div class="demo-carousel">
          <img 
          v-if="item&&item.amtopics&&(String(item.amtopics).startsWith('http')||String(item.amtopics).startsWith('https'))" 
          :src="item.amtopics" 
          alt="" 
          >
          <img  v-else  src="../imgs/noViewPic.jpg" />
        </div>
      </CarouselItem>
    </Carousel>
    <div class="iviewInfo">
      <div class="tit" v-html="title" @click="gotoDetail()"></div>
      <p v-html="info?info:'暂无介绍'"></p>
    </div>
  </div>
  <div v-else class="noData" >暂无数据</div>
</template>
<script>
export default {
  props: {
    dataArr: {
      type: Array,
      default: []
    }
  },
  data () {
    return {
      title: '',
      info: '',
      amid: '',
      Carousel: {
        indx: 0,
        setting: {
          height: 160,
          autoplay: true,
          autoplaySpeed: 3000,
          dots: 'inside',
          radiusDot: true,
          trigger: 'click',
          arrow: 'never'
        },
      },
    }
  },
  created () {
    this.title = this.dataArr.length ? this.dataArr[0].amtopicf : '';
    this.info = this.dataArr.length ? this.dataArr[0].amdesc : '';
    this.amid = this.dataArr.length ? this.dataArr[0].amid : '';
  },
  watch: {
    'Carousel.indx': {
      handler: function (index, oldIndex) {
        this.title = this.dataArr[index].amtopicf
        this.info = this.dataArr[index].amdesc
        this.amid = this.dataArr[index].amid
      },
      deep: true
    }
  },
  methods: {
    gotoDetail () {
      this.$router.push({
        name: 'articleDetail',
        params: {
          aId: this.amid,
          part: '新鲜资讯',
          partName: 'information'
        }
      });
    }
  }
}
</script>
<style lang="less" scoped>
@fontSize12: 12px;
@fontSize17: 17px;
@titColor: #323233;
@wordColor: #646566;
@tithover: #4b7ff0;
img {
  width: 100%;
  height: 100%;
}
.iviewInfo {
  font-size: @fontSize12;
  height: 100px;
  .tit {
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: 500;
    line-height: 50px;
    font-size: @fontSize17;
    color: @titColor;
    &:hover {
      color: @tithover;
    }
  }
  p {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    color: @titColor;
    line-height: 25px;
  }
}
// 暂无数据样式
.noData {
  text-align: center;
  line-height: 250px;
}
</style>

<style scoped>
.freshNew >>> .ivu-carousel-dots-inside {
  bottom: 10px;
  right: -105px;
}
.freshNew >>> .ivu-carousel-dots li {
  margin: 0 2px;
}
.freshNew >>> .ivu-carousel-dots li button {
  background: #fff;
  opacity: 1;
  border: 1px solid #ffffff;
  border-radius: 100px;
  width: 16px;
  height: 8px;
}
.freshNew >>> .ivu-carousel-dots .ivu-carousel-active button {
  background: #4b7ff0;
  border: 1px solid #4b7ff0;
}
</style>
